// Seeded rows of the accreditations catalogue (the supplier "Verifier" picker). Branch on these
// ids, never on the row name. Seeded by the backend migration
// 20251021135438-data-populate-accreditations-table.js.
export const OTHER_ACCREDITATION_ID = 'd8d91c9c-e535-4709-b008-b6799ebf65ff'
// ISO 14001 sits in the verifier list although it certifies an environmental management system
// rather than carbon targets; the supplier form shows a hint pointing at Certifications.
export const ISO_14001_ACCREDITATION_ID = 'b8f4aad9-247e-4995-84b5-d9d69a072133'
